import { Routes } from '@angular/router';
import { PeriodRepository } from './repositories/period.repository';
import { PeriodService } from './services/period.service';
import { RevenueRepository } from './repositories/revenue.repository';
import { TiredBonusRepository } from './repositories/tired-bonus.repository';
import { BonusabfrageQueryService } from './services/bonusabfrage-query.service';
import { TiredBonusService } from './services/tired-bonus.service';
import { RevenueService } from './services/revenue.service';

export const bonusabfrageRoutes: Routes = [
  {
    path: 'bonusabfrage',
    loadComponent: () =>
      import('./pages/bonusabfrage.component').then((o) => o.BonusabfrageComponent),
    providers: [
      PeriodRepository,
      PeriodService,
      RevenueRepository,
      RevenueService,
      TiredBonusRepository,
      TiredBonusService,
      BonusabfrageQueryService,
    ],
  },
];
